export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11485.3473df70.jpg";